module.exports = __webpack_public_path__ + "static/media/xiangyangshan_plant.cd659628.webp";